const styles = {
  input: {
    width: '100%',
  },
  field: {
    position: 'relative',
    '& .MuiFormHelperText-root': {
      position: 'absolute',
      bottom: 0,
      transform: 'translateY(100%)',
      paddingTop: '4px',
      fontSize: '13px',
      lineHeight: '21px',
    },
    '& .MuiFormHelperText-root.Mui-error': {
      color: 'kit.text.error',
    },

    '& .MuiInputLabel-root': {
      fontSize: '13px',
    },
  },
  submitBlock: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
  },
  submit: {
    opacity: 1,
    transition: '.3s',
    '&:disabled': {
      opacity: 0.8,
    },
  },
};

export default styles;
